import { render, staticRenderFns } from "./pane.vue?vue&type=template&id=3a9be0cd&"
import script from "./pane.vue?vue&type=script&lang=js&"
export * from "./pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a9be0cd')) {
      api.createRecord('3a9be0cd', component.options)
    } else {
      api.reload('3a9be0cd', component.options)
    }
    module.hot.accept("./pane.vue?vue&type=template&id=3a9be0cd&", function () {
      api.rerender('3a9be0cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/split/pane.vue"
export default component.exports